import { Outlet, useParams } from "react-router-dom";
import { useTableSocket } from "@/hooks/useTableSocket";

/**
 * Everything under /restaurants/:restaurantId/tables/:tableId shares one live
 * socket connection — the bill screens and the ordering flow alike.
 */
function TableScopeLayout() {
  const { restaurantId = "", tableId = "" } = useParams<{
    restaurantId: string;
    tableId: string;
  }>();

  useTableSocket(restaurantId, tableId);

  return <Outlet />;
}

export default TableScopeLayout;
